import { render, staticRenderFns } from "./CreatorServiceOrders.vue?vue&type=template&id=4b023593&scoped=true&"
import script from "./CreatorServiceOrders.vue?vue&type=script&lang=js&"
export * from "./CreatorServiceOrders.vue?vue&type=script&lang=js&"
import style0 from "./CreatorServiceOrders.vue?vue&type=style&index=0&id=4b023593&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b023593",
  null
  
)

export default component.exports